import React from 'react'
import { Link } from "react-router-dom";


const ElectricalServices = () => {
    return (
        <>
            <section className="page_breadcrumb" style={{ background: 'url(assets/img/breadcrumb_bg.webp)' }}>
                <div className="breadcrumb_overlay">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="breadcrumb_text">
                                    <h1>Electrical Services</h1>
                                    <ul className="d-flex flex-wrap">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="/">Electrical Services</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="services_details pt_120 xs_pt_100" style={{marginTop:"-80px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                            <div className="services_details_img">
                                <img src="assets/img/Electrical Services_01.webp" alt="service" className="img-fluid w-100" />
                            </div>
                            <div className="services_details_area">
                                <h2 className="details_title">Electrical Services</h2>

                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabIndex={0}>
                                        <div className="service_details_overview">
                                            <p style={{textAlign:"justify"}}>Our certified electricians provide reliable electrical installation, repair, maintenance, and safety inspection services for residential, commercial, and industrial properties.</p>
                                            <h3>Services Include:</h3>
                                            <ul>
                                                <li> Electrical Installation</li>
                                                <li> Wiring & Rewiring</li>
                                                <li>Electrical Repairs</li>
                                                <li>  Panel Maintenance </li>
                                                <li> Safety Inspection</li>
                                                <li> AMC Services</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="blog_page pt_95 xs_pt_75" style={{marginTop:"-90px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="row">
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Financial Planning.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Investment Advisory.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Tax Planning.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-4 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <div className="single_blog">
                                        <Link to="/blog-details" className="single_blog_img">
                                            <img src="assets/img/Retirement Planning.webp" alt="Blog" className="img-fluid" />
                                        </Link>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

        </>
    )
}

export default ElectricalServices
